// extracted by mini-css-extract-plugin
export default {"cabecera":"CabeceraTorneosPais_cabecera__a2UCM","volver":"CabeceraTorneosPais_volver__nPgCK"};